let loading;

export function loadTurnstile({ document: doc = globalThis.document, window: win = globalThis.window, nonce } = {}) {
  if (win?.turnstile) return Promise.resolve(win.turnstile);
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const script = doc.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    script.async = true;
    script.defer = true;
    if (nonce) script.nonce = nonce;
    const timer = setTimeout(() => { script.remove(); loading = undefined; reject(new Error('Verification could not load. Please try again.')); }, 15000);
    script.onload = () => {
      clearTimeout(timer);
      if (!win.turnstile) { loading = undefined; reject(new Error('Verification could not load. Please try again.')); return; }
      resolve(win.turnstile);
    };
    script.onerror = () => { clearTimeout(timer); loading = undefined; script.remove(); reject(new Error('Verification could not load. Please try again.')); };
    doc.head.appendChild(script);
  });
  return loading;
}

export async function mountTurnstile(container, { siteKey, action = 'lead', onToken = () => {}, onError = () => {}, nonce, api } = {}) {
  if (!container || !siteKey) throw new Error('A container and public site key are required.');
  let token = '';
  let active = true;
  const clear = () => { token = ''; if (active) onToken(''); };
  clear();
  let provider;
  try { provider = api || await loadTurnstile({ nonce }); }
  catch (error) { onError(error.message); throw error; }
  const id = provider.render(container, {
    sitekey: siteKey, action, theme: 'auto', size: 'flexible', appearance: 'interaction-only',
    'response-field': true, 'response-field-name': 'cf-turnstile-response',
    'refresh-expired': 'auto', 'refresh-timeout': 'auto',
    callback: value => { if (active) { token = value; onError(''); onToken(value); } },
    'expired-callback': clear,
    'timeout-callback': () => { clear(); onError('Verification timed out. Please try again.'); },
    'error-callback': () => { clear(); onError('Verification could not finish. Please try again.'); return true; },
  });
  return {
    getToken: () => token,
    reset() { if (active) { clear(); onError(''); provider.reset(id); } },
    destroy() { if (active) { clear(); active = false; provider.remove(id); } },
  };
}
